import {
  Box,
  Button,
  MenuItem,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from '@chakra-ui/react';

import { GET_TOURS } from '../../../../graphql/queries';
import { useAlert } from '../../../../hooks';
import { useRemoveTourMutation } from '../../../../hooks/useMutations';
import { styles } from './styles';

const DeleteTourModal = ({ tourData }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { showAlert } = useAlert();
  const [removeTourMutation] = useRemoveTourMutation();

  const handleDeleteReview = () => {
    removeTourMutation({
      variables: {
        /* eslint-disable-next-line no-underscore-dangle */
        id: tourData?._id,
      },
      onCompleted: () => {
        showAlert({
          message: 'Тур успешно удалён.',
          variant: 'info',
        });
      },
      onError: () => {
        showAlert({
          message: 'Произошла ошибка при удалении тура!',
          variant: 'error',
        });
      },
      refetchQueries: [GET_TOURS],
    });
    onClose();
  };

  return (
    <>
      <MenuItem sx={styles.menuDeleteText} onClick={onOpen}>
        Удалить
      </MenuItem>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Удаление</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Box>
              <Text>Вы действительно хотите удалить Тур?</Text>
              <Box>
                <Box sx={styles.modalTextWrapper}>
                  <Text fontSize='xl' mr='0.5vw' minW='3.5vw'>
                    Название:
                  </Text>
                  <Text>{tourData.name}</Text>
                </Box>
                <Box sx={styles.modalTextWrapper}>
                  <Text fontSize='xl' mr='0.5vw' minW='3.5vw'>
                    ID:
                  </Text>
                  {/* eslint-disable-next-line no-underscore-dangle */}
                  <Text>{tourData?._id}</Text>
                </Box>
              </Box>
            </Box>
          </ModalBody>
          <ModalFooter>
            <Button variant='solid' colorScheme='red' mr={3} onClick={handleDeleteReview}>
              Удалить
            </Button>
            <Button colorScheme='blue' onClick={onClose}>
              Отмена
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default DeleteTourModal;
